import { useEffect } from "react";

// Hotfix Chrome 146.0.7680.80 - The player breaks the layout after loading tabmenu
const useHotfixPlayer = (path = null) => {
  useEffect(() => {
    (window['window_resize']) && window['window_resize']();
  }, [path])
  return null;
};

export default useHotfixPlayer;
